import { render, staticRenderFns } from "./BrandTutorialVideoItem.vue?vue&type=template&id=69fd829c&scoped=true&"
import script from "./BrandTutorialVideoItem.vue?vue&type=script&lang=ts&"
export * from "./BrandTutorialVideoItem.vue?vue&type=script&lang=ts&"
import style0 from "./BrandTutorialVideoItem.vue?vue&type=style&index=0&id=69fd829c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fd829c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69fd829c')) {
      api.createRecord('69fd829c', component.options)
    } else {
      api.reload('69fd829c', component.options)
    }
    module.hot.accept("./BrandTutorialVideoItem.vue?vue&type=template&id=69fd829c&scoped=true&", function () {
      api.rerender('69fd829c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/BrandTutorialVideoItem.vue"
export default component.exports